import { BasicEvent } from "./BasicEvent";
export class ArbetsorderMaskinlagUpdatedMessage extends BasicEvent {
    arbetsorderId: number;
    arbetsorderGuid: string;
    maskinlagId?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderMaskinlagUpdatedMessage";
    constructor() {
        super(ArbetsorderMaskinlagUpdatedMessage.$type);
    }
}
